import { Component, OnInit, ViewChild } from "@angular/core";
import { ModalComponent } from "../modal/modal.component";
import * as moment from "moment/moment";
import { CommonService } from "src/app/common.service";
import { FormGroup, FormControl } from "@angular/forms";
import { ShowcaseList, ShowcaseCard } from "showcase-api";
import { Profile } from "profile-api";
import { Router } from "@angular/router";

@Component({
  selector: "app-showcase-professional",
  templateUrl: "./showcase-professional.component.html",
  styleUrls: ["./showcase-professional.component.css"],
})
export class ShowcaseProfessionalComponent implements OnInit {
  @ViewChild("unauthorizedModal") unauthorizedModal: ModalComponent;

  professionalSectorCodes = [];

  showcaseId: number;
  pageSize: number = 5;
  pageNumber: number = 0;
  professionalName = null;
  location: string;
  address: string;
  sectorProfessionalList = null;
  generalContractor = null;
  sectorOrPartialContractor = null;
  companySizeList = null;
  employer: string;
  designer: boolean = true;
  error = "no_error";
  sectorProfessionalSelected = null;
  sizeList = null;
  specializationProfessonalList = null;

  publicProfessionalCards: Array<ShowcaseCard> = [];
  showMoreProfesionals: boolean = false;
  typeProfessionalList = null;

  searchForm = new FormGroup({
    professionalName: new FormControl(null),
    professionalLocation: new FormControl(null),
    professionalAddress: new FormControl(null),
    professionalSectorCode: new FormControl(null),
    employer: new FormControl(null),
  });
  profile: Profile = {};

  constructor(private commonService: CommonService, private router: Router) {}

  ngOnInit(): void {
    window["moment"] = moment;
    this.profile = JSON.parse(localStorage.getItem("PROFILE"));

    this.commonService
      .getProfile()
      .then((profile: Profile) => {
        console.log("User logged in");
        this.profile = profile;
        if (!profile.registryCompleted) {
          this.unauthorizedModal.open();
        }else {
          this.searchCompanies();
        }
    }).catch((error) => {
      console.log("User not logged in. Redirect to login");
      console.log(error);
      this.router.navigate(["/login"], {
        queryParams: {
          fromDesignerShowcase: "yes"
        },
      });
    });

    //sectorProfessionalList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SECTOR_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.sectorProfessionalList = data.items;
          console.log(
            "Professional Sector: " +
              JSON.stringify(this.sectorProfessionalList)
          );
        },
        (error) => {
          this.error =
            "Impossibile caricare la lista di settori dei professionisti.";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SPECIALIZATION_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.specializationProfessonalList = data.items;
          console.log(
            "Professional Sector: " +
              JSON.stringify(this.specializationProfessonalList)
          );
        },
        (error) => {
          this.error =
            "Impossibile caricare la lista di settori dei professionisti.";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("TYPE_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.typeProfessionalList = data.items;
          console.log(
            "Professional Sector: " + JSON.stringify(this.typeProfessionalList)
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista typeProfessionalList";
          console.log(error);
        }
      );

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SIZE_COMPANY")
      .subscribe(
        (data) => {
          this.sizeList = data.items;
          console.log("Professional Sector: " + JSON.stringify(this.sizeList));
        },
        (error) => {
          this.error = "Impossibile caricare la lista sizeList";
          console.log(error);
        }
      );

  }

  searchCompanies() {
    if (!this.profile.registryCompleted) {
      this.unauthorizedModal.open();
      return;
    }
    this.pageNumber = 0;
    this.publicProfessionalCards = [];

    this.sectorProfessionalSelected = this.searchForm.get(
      "professionalSectorCode"
    ).value;
    this.location = this.searchForm.get("professionalLocation").value;
    this.address = this.searchForm.get("professionalAddress").value;
    this.professionalName = this.searchForm.get("professionalName").value;
    this.employer = this.searchForm.get("employer").value;

    if (this.sectorProfessionalList) {
      localStorage.setItem("SECTOR_PROFESSIONAL", this.sectorProfessionalList);
    } else {
      localStorage.setItem("SECTOR_PROFESSIONAL", null);
    }

    if (this.location) {
      localStorage.setItem("SEARCH_LOCATION", this.location);
    } else {
      localStorage.setItem("SEARCH_LOCATION", "");
    }

    if (this.address) {
      localStorage.setItem("ADDRESS_COMPANY", this.address);
    } else {
      localStorage.setItem("ADDRESS_COMPANY", "");
    }

    if (this.professionalName) {
      localStorage.setItem("NAME_PROFESSIONAL", this.professionalName);
    } else {
      localStorage.setItem("NAME_PROFESSIONAL", "");
    }

    console.log(
      "Sector = " +
        this.sectorProfessionalList +
        "; location = " +
        this.location +
        "; address = " +
        this.address +
        "; Professional name = " +
        this.professionalName +
        "; Employer = " +
        this.employer
    );

    this.loadCards();
  }

  loadCards() {
    this.commonService
      .getShowcaseService()
      .showcaseGet(
        this.showcaseId,
        this.pageSize,
        this.pageNumber,
        this.professionalName,
        this.location,
        this.sectorProfessionalSelected,
        this.generalContractor,
        this.sectorOrPartialContractor,
        this.companySizeList,
        this.employer,
        (this.designer = true)
      )
      .subscribe(
        (res: ShowcaseList) => {
          console.log("Showcase list: " + JSON.stringify(res));
          this.publicProfessionalCards = this.publicProfessionalCards.concat(
            res.profileDetails
          );
          this.showMoreProfesionals =
            res.paging.pageNumber < res.paging.totalPages - 1;

          localStorage.removeItem("SHOWCASE_ID");
          this.showcaseId = null;
          console.log(
            "Public professional cards:" +
              JSON.stringify(this.publicProfessionalCards)
          );
        },
        (error) => {
          console.error(error);

          localStorage.removeItem("SHOWCASE_ID");
          this.showcaseId = null;
        }
      );
  }

  GetSpecializationDescription(code: string) {
    for (let i of this.specializationProfessonalList) {
      if (i.code == code) {
        return i.description;
      }
    }
  }

  loadMoreCards() {
    this.pageNumber = this.pageNumber + 1;
    this.loadCards();
  }

  getSocietyType(code: string) {
    for (let i of this.typeProfessionalList) {
      if (i.code == code) {
        return i.description;
      }
    }
  }

  getSectorType(code: string) {
    for (let i of this.sectorProfessionalList) {
      if (i.code == code) {
        return i.description;
      }
    }
  }
  getCompanySize(code: string) {
    for (let i of this.sizeList) {
      if (i.code == code) {
        return i.description;
      }
    }
    return null;
  }

  unauthorizedModalSubmit() {
    this.router.navigate(['/areariservata'], { queryParams: { tabToLoad: 'profile', fromRestrictedArea: true, returnResource:  'professionisti'} });
    this.unauthorizedModal.close();
  }
}
